import { MapPin, Phone, Mail } from "lucide-react";
import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import { CONTACT } from "@/data/content";

export default function Contact() {
  return (
    <div className="pt-24 md:pt-32">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32">
        <Reveal>
          <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-neutral-500">
            <span className="inline-block w-6 h-px bg-neutral-400" />
            Get in Touch
          </span>
          <h1 className="mt-6 font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight max-w-5xl">
            Connect with our tech experts.
          </h1>
          <p className="mt-8 text-lg text-neutral-600 max-w-3xl leading-relaxed">
            Have questions? We&rsquo;re here to help with software development, AI solutions, internships
            and enterprise technology services.
          </p>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4 space-y-6">
            <InfoBlock icon={MapPin} label="Our Office" value={CONTACT.address} />
            <InfoBlock icon={Phone} label="Phone Support" value={CONTACT.phone} href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} />
            <InfoBlock icon={Mail} label="Email Address" value={CONTACT.email} href={`mailto:${CONTACT.email}`} />
          </div>
          <div className="lg:col-span-8">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}

function InfoBlock({ icon: Icon, label, value, href }) {
  const content = (
    <div className="border border-neutral-200 rounded-2xl p-6 hover:border-neutral-900 transition-colors">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-full border border-neutral-200 grid place-items-center shrink-0">
          <Icon className="w-4 h-4" strokeWidth={1.5} />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-neutral-500">{label}</div>
          <div className="mt-1 text-neutral-900 leading-relaxed">{value}</div>
        </div>
      </div>
    </div>
  );
  return href ? <a href={href}>{content}</a> : content;
}
